// Utility functions for product-related logic

// List of productType values that are considered accessories
const ACCESSORY_TYPES = ['Bags', 'Stole', 'Bandana', 'Tie'];
const BOTTOM_TYPE_KEYWORDS = [
  'pant',
  'pants',
  'short',
  'skirt',
  'bottom',
  'trouser',
  'jean',
  'denim',
  'jogger',
  'palazzo',
  'culotte',
  'legging',
  'pyjama',
  'pajama',
  'lower',
];

/**
 * Check if a product is an accessory based on its productType
 * @param {string} productType - The productType value from the product
 * @returns {boolean} - True if the product is an accessory
 */
export const isAccessory = (productType) => {
  if (!productType) return false;
  return ACCESSORY_TYPES.includes(productType);
};

/**
 * Get all accessory productType values
 * @returns {string[]} - Array of accessory productType values
 */
export const getAccessoryTypes = () => {
  return [...ACCESSORY_TYPES];
};

/**
 * Check if a product should allow bottom-specific customization controls.
 * It checks productType first and then falls back to product name/title text.
 * @param {string} productType
 * @param {string} fallbackText
 * @returns {boolean}
 */
export const isBottomProductType = (productType, fallbackText = '') => {
  const haystack = `${String(productType || '')} ${String(fallbackText || '')}`.toLowerCase();
  return BOTTOM_TYPE_KEYWORDS.some((keyword) => haystack.includes(keyword));
};
